module.exports = __webpack_public_path__ + "static/2Front-logo-black-499d243a2bd20574e399a69db528af87.png";